<template>
	<div class="box">
		<div class="box-header with-border">
			<h1 class="box-title">Configurações</h1>
		</div>
		<div class="box-body">
			<div class="row">
				<div class="col-sm-6">
					<b>Mercado pago</b>
					<div class="well well-sm">
						<span>Chave publica</span>
						<input
							v-model="findSetting('chave_publica').data"
							type="text"
							class="form-control"
						/>
						<span>Chave Privada</span>
						<input
							v-model="findSetting('chave_privada').data"
							type="text"
							class="form-control"
						/>
					</div>
				</div>
				<div class="col-sm-6">
					<b>Termos</b>
					<div class="well well-sm">
						<span>Termo de parceria</span>
						<select
							class="form-control"
							v-model="findSetting('termo_parceria').data"
						>
							<option
								v-for="(itTmp, index) in tmp"
								:key="index"
								:value="itTmp.cod"
							>
								{{ itTmp.titulo }}
							</option>
						</select>
						<span>Termo de contrato</span>
						<select
							class="form-control"
							v-model="findSetting('termo_contrato').data"
						>
							<option
								v-for="(itTmp, index) in tmp"
								:key="index"
								:value="itTmp.cod"
							>
								{{ itTmp.titulo }}
							</option>
						</select>
					</div>
				</div>
				<div class="col-sm-6">
					<b>Perfil dos usuários</b>
					<div class="well well-sm">
						<span>Empresa</span>
						<select
							class="form-control"
							v-model="findSetting('perfil_sms_empresa').data"
						>
							<option
								v-for="(perfil, index) in perfis"
								:key="index"
								:value="perfil.cod"
							>
								{{ perfil.desc }}
							</option>
						</select>
						<span>Associado</span>
						<select
							class="form-control"
							v-model="findSetting('perfil_sms_associado').data"
						>
							<option
								v-for="(perfil, index) in perfis"
								:key="index"
								:value="perfil.cod"
							>
								{{ perfil.desc }}
							</option>
						</select>
					</div>
				</div>
				<div class="col-sm-6">
					<b>Chat</b>
					<div class="well well-sm">
						<span>Analista</span>
						<select
							v-model="findSetting('chat_analist').data"
							class="form-control"
						>
							<option
								v-for="(item, index) in login"
								:key="index"
								:value="item.cod"
							>
								{{ item.user }}
							</option>
						</select>

						<span>Mensagem Inicial</span>
						<input
							type="text"
							v-model="findSetting('chat_default_mesage').data"
							class="form-control"
						/>
					</div>
				</div>
				<div class="col-sm-6">
					<b>Comissão inicial</b>
					<div class="well well-sm">
						<span>Valor em %</span>
						<input
							type="number"
							v-model="findSetting('sms_default_percent').data"
							class="form-control"
						/>
					</div>
				</div>
			</div>
		</div>
		<div class="box-footer">
			<div class="pull-right">
				<button class="btn btn-success" @click="saveSettings">
					<i class="fa fa-save"></i>
					Salvar
				</button>
			</div>
		</div>
	</div>
</template>
<script>
	import WBS from 'js/http';
	import clone from 'js/clone';
	import toastr from 'toastr';

	export default {
		name: 'AppSettings',
		data() {
			return {
				settings: [],
				oldSettings: [],
				tmp: [],
				perfis: [],
				login: [],
			};
		},
		methods: {
			saveSettings() {
				WBS.send(
					'private-save-sstSettings',
					{ s: this.settings },
					(resp) => {
						if (resp.status == 'success') {
							toastr.success('Configurações salvas com sucesso!');
						} else {
							toastr.error(resp.msg[0]);
						}
					}
				);
			},
			findSetting(id) {
				let set = this.settings.find((i) => i.id === id);
				if (set == undefined) return { data: '' };
				else return set;
			},
		},
		mounted() {
			this.$emit('setHeader', ['Configuração do App', '']);
			WBS.send('private-read-sstSettings', (resp) => {
				if (resp.status == 'success') {
					this.login = resp.data.login;
					this.perfis = resp.data.perfis;
					this.settings = resp.data.settings;
					this.oldSettings = clone(resp.data.settings);
					this.tmp = resp.data.tmp;
				}
			});
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/app-settings/index.vue